import React, {useContext, useState} from "react";
import {ImageComponentProps} from "../../core/_models";
import {Image, Modal} from 'react-bootstrap'
import {KTSVG} from "../../../../../_metronic/helpers";

export function ImageComponent({config, context}: ImageComponentProps) {
    const {value, readOnly, id, withPreview, label} = config;
    const [modal, setModal] = useState(false);

    const [image, setImage] = useState(value);

    const formContext = useContext(context);

    const onClick = () => {
        setModal(true);
    }

    const encodeImageFileAsURL = (element: HTMLInputElement) => {
        if (element.files == null) {
            return
        }

        const file = element.files[0];
        const reader = new FileReader();
        reader.onloadend = function () {
            const result = reader.result;
            setImage(result);
            formContext.set(id, result);
        }
        reader.readAsDataURL(file);
    }

    return (
        <div>
            {label && <div>{label}</div>}
            {image && withPreview !== false && <a
                className='embed-responsive'
                style={{cursor: 'zoom-in'}}
                onClick={(e) => {
                    e.preventDefault()
                    onClick()
                }}
            >
                <Image src={image} alt={'IMAGE'} fluid/>
            </a>}
            {!readOnly &&
                <div className="py-2"><input type="file" onChange={(e) => encodeImageFileAsURL(e.target)}/></div>}
            {modal && <Modal
                id='kt_image_preview_modal'
                tabIndex={-1}
                aria-hidden='true'
                dialogClassName='modal-dialog modal-dialog-centered mw-900px'
                show={true}
                onHide={() => setModal(false)}
            >
                <div className='modal-header'>
                    <h2>Image Viewer</h2>
                    {/* begin::Close */}
                    <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={() => setModal(false)}>
                        <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg'/>
                    </div>
                    {/* end::Close */}
                </div>
                <div className='modal-body py-lg-10 px-lg-10' style={{cursor: 'zoom-out'}}
                     onClick={() => setModal(false)}>
                    <Image
                        src={value}
                        alt='Image Preview'
                        fluid
                    />
                </div>
            </Modal>}
        </div>
    )
}